import { History } from "lucide-react";
import { prettyDate } from "@/lib/geo";

export const Timeline = ({ visited, onFocus }) => {
  const trips = visited
    .flatMap((v) => (v.trips || []).map((t) => ({ ...t, country: v.country })))
    .sort((a, b) => a.date.localeCompare(b.date));

  return (
    <div className="mt-6 rounded-2xl border border-white/10 bg-[#131A26] p-5" data-testid="travel-timeline">
      <div className="flex items-baseline justify-between mb-4">
        <div>
          <p className="eyebrow">Timeline</p>
          <h3 className="font-display text-xl font-semibold mt-1">Where I've been, when</h3>
        </div>
        <span className="font-mono text-xs text-slate-500" data-testid="timeline-count">{trips.length} {trips.length === 1 ? "visit" : "visits"}</span>
      </div>
      {trips.length === 0 ? (
        <p className="text-sm text-slate-500 flex items-center gap-2" data-testid="timeline-empty"><History size={15} /> Add visit dates in "Been there" to build your timeline.</p>
      ) : (
        <div className="overflow-x-auto pb-2">
          <ol className="relative flex gap-4 min-w-max pt-6">
            <span className="absolute top-[11px] left-0 right-0 h-px bg-gradient-to-r from-emerald-500/60 via-emerald-500/30 to-transparent" />
            {trips.map((t, i) => {
              const year = t.date.slice(0, 4);
              const newYear = i === 0 || trips[i - 1].date.slice(0, 4) !== year;
              return (
                <li key={`${t.country}-${t.date}-${i}`} className="relative w-44 animate-rise" style={{ animationDelay: `${Math.min(i, 10) * 50}ms` }} data-testid={`timeline-item-${i}`}>
                  {newYear && <span className="absolute -top-6 left-0 font-mono text-[11px] text-emerald-400">{year}</span>}
                  <span className="absolute -top-[17px] left-1 w-3 h-3 rounded-full bg-emerald-400 ring-4 ring-[#131A26] shadow-[0_0_10px_#34D399]" />
                  <button onClick={() => onFocus(t.country)} className="mt-3 w-full text-left rounded-xl border border-white/5 bg-white/[0.02] p-3 hover:border-emerald-500/40 hover:-translate-y-0.5 transition-[transform,border-color] duration-200" data-testid={`timeline-focus-${i}`}>
                    <p className="font-mono text-[10px] text-slate-500">{prettyDate(t.date)}</p>
                    <p className="font-medium truncate">{t.country}</p>
                    {t.note && <p className="text-xs text-slate-400 truncate mt-0.5">{t.note}</p>}
                  </button>
                </li>
              );
            })}
          </ol>
        </div>
      )}
    </div>
  );
};
